export default {
  sortByLoanAmount: 'None',
  sortByGrantAmount: 'None',
  sortByInterestRate: 'None',
  sortByDecisionTime: 'None',
  sortByProductType: ''
}
